<!--
Copyright 2021 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

@if (!(complete$ | async)) {
  <crucible-dialog
    [dialogTitle]="'Import ' + (typeString | titlecase) + ': ' + name"
    [form]="form"
    submitLabel="Import"
    [submitDisabled]="!form.valid"
    (cancel)="cancel()"
    (submit)="import()"
  >
    <div crucibleDialogContent [formGroup]="form">
      <div class="import-fields">
        <div class="file-row">
          <button
            type="button"
            mat-stroked-button
            cdkFocusInitial
            (click)="fileInput.click()"
          >
            Choose File
          </button>
          <input
            hidden
            (change)="onFileSelected($event)"
            #fileInput
            type="file"
            accept=".zip, .tar.gz, .tgz"
          />
          <span class="file-name">{{ this.form.value.archive?.name }}</span>
        </div>

        <div class="toggle-row">
          <mat-label>Preserve Ids</mat-label>
          <mat-slide-toggle
            formControlName="preserveIds"
            matTooltip="Optionally use the same Ids on import, if the archive included Ids on export. Otherwise, generate new Ids"
          ></mat-slide-toggle>
        </div>
      </div>
    </div>
  </crucible-dialog>
} @else {
  <crucible-dialog [dialogTitle]="'Import ' + (typeString | titlecase) + ': ' + name" [hideDefaultActions]="true">
    <div crucibleDialogContent>
      @if (lockedFiles.length > 0) {
        <p role="alert" class="import-error">
          Error: The following files are locked and were unable to be updated:
        </p>
        <ul>
          @for (file of lockedFiles; track file) {
            <li>{{ file }}</li>
          }
        </ul>
      } @else {
        <p>Import Successful</p>
      }
    </div>

    <ng-container crucibleDialogActions>
      <button
        mat-flat-button
        color="primary"
        type="button"
        cdkFocusInitial
        (click)="cancel()"
      >
        OK
      </button>
    </ng-container>
  </crucible-dialog>
}
